import layoutHeaderAside from '@/layout/header-aside';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/mobile/',
  name: 'mobile',
  meta: {
    auth: true
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'app',
      name: `${pre}app`,
      component: _import('mobile/app'),
      meta: {
        title: '移动端app'
      }
    },
    {
      path: 'mp',
      name: `${pre}mp`,
      component: _import('mobile/mp'),
      meta: {
        title: '小程序'
      }
    },
    {
      path: 'zb',
      name: `${pre}zb`,
      component: _import('mobile/zbapp'),
      meta: {
        title: '直播APP'
      }
    }
  ])('mobile/')
}
